<template>
  <a-layout-content style="margin: 16px">

      <div
        :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
      >
        <a-form-model
          ref="ruleForm"
          layout="inline"
          :model="formInline"
          @submit="handleSubmit"
          @submit.native.prevent
        >
          <a-row>
            <a-col :span="6">
              <a-form-model-item label="会员卡号" prop="user">
                <a-input v-model="formInline.cardNo" placeholder="请输入">
                  <a-icon
                    slot="prefix"
                    type="user"
                    style="color: rgba(0, 0, 0, 0.25)"
                  />
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="4">
              <a-form-model-item>
                <a-button type="primary" html-type="submit"> 查询 </a-button>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
    <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
      <a-table
        :columns="columns"
        :data-source="data"
        :pagination="pagination"
        :loading="loading"
        :row-key="(item) => item.categoryName"
        @change="handleTableChange"
        size="middle"
      >
      </a-table>
    </div>
  </a-layout-content>
</template>
<script>
import {
  storeClassification,
  shopListDetails,
  storeClassificationEdit,
  storeClassificationAdd,
  storeClassificationDel,
} from "@/api/storeApi";
import { page } from "../../../utils/page";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "编号",
    dataIndex: "code",
    scopedSlots: { customRender: "code" }
  },
  {
    title: "会员卡号",
    dataIndex: "cardNo",
    scopedSlots: { customRender: "cardNo" },
  },
  {
    title: "提现时间",
    dataIndex: "createTime",
    scopedSlots: { customRender: "createTime" },
  },
  {
    title: "提现币数量",
    dataIndex: "coinNum",
    scopedSlots: { customRender: "coinNum" },
  }
];

export default {
  name: 'ticketPackageDetails',
  data() {
    return {
      data: [],
      updateId: null,
      formInline: {
        cardNo: "", // 输入的分类名称
        sortNum: "", // 输入的显示数据
      },
      formInlinetwo: {
        categoryNametwo: "", // 输入的分类名称
        sortNumtwo: "", // 输入的显示数据
      },
      loading: false,
      columns,
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
    };
  },
  created() {
    this.getStoreClassification();
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      shopListDetails( sessionStorage.getItem('shopId'), this.formInline.cardNo,  this.pagination.current).then(
        (res) => {
          this.pagination.total = res.count;
          this.data = page(res.data, this.pagination.current, this.pagination.pageSize);
          console.log(res);
          this.loading = false;
        }
      );
      this.loading = false;
    },
    getStoreClassification() {
      shopListDetails( sessionStorage.getItem('shopId'),  '' ).then((res) => {
        this.pagination.total = res.count;
        this.data = page(res.data, this.pagination.current, this.pagination.pageSize);
      });
    },

    handleSubmit() {
      shopListDetails( sessionStorage.getItem('shopId'),  this.formInline.cardNo ).then((res) => {
        this.pagination.total = res.count;
        this.data = page(res.data, this.pagination.current, this.pagination.pageSize);
      });

    },


  },
};
</script>



// WEBPACK FOOTER //
// src/views/marketingManagement/ticketPackage/ticketPackageDetails.vue